/**
 * Within the scope of a given user, an entity is unique by its name, pro and role type. Since we
 * don't currently have access to the entity_id for a percent_share within trqkSong.percent_shares,
 * we can use these three properties to match a percent_share back to its associated entity.
 * @param input
 */
export const getCompositeEntityKey = (input: {
    name: string;
    pro?: Maybe<string>;
    roleType?: Maybe<ProRoleType>;
}): Maybe<string> => {
    if (!input.roleType || !input.pro) {
        return null;
    }

    return `${input.name}.${input.roleType}.${input.pro}`;
};
